import { Observable, pipe, of, forkJoin } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Fetch } from '@app/models/fetch';
import { Cache } from '@app/models/cache';
import { Device } from '@app/models/devices/devices.model';
import { config } from '@config/config';
import * as i0 from "@angular/core";
import * as i1 from "../fetch";
import * as i2 from "../cache";
export class DeviceService {
    constructor(fetch, cache) {
        this.fetch = fetch;
        this.cache = cache;
        this.baseUrl = '/devices';
        this.cacheName = 'devices';
        this.cache.register(this.cacheName, Device, 60);
    }
    get(id) {
        return this.cache.getOne(this.cacheName, id, this.fetch.getOne(this.baseUrl, id));
    }
    getFromLocation(loc) {
        return this.cache
            .getAll(this.cacheName, this.fetch.getAll(this.baseUrl, { list_shared: true }))
            .pipe(map((models) => ({
            br: models.find((dev) => dev.location_id === loc.id && dev.type === config.deviceTypes.BRIDGE),
            ws: models.find((dev) => dev.location_id === loc.id && dev.type === config.deviceTypes.WS),
        })));
    }
    getAll() {
        return this.cache.getAll(this.cacheName, this.fetch.getAll(this.baseUrl));
    }
    joinNotifications(notifs) {
        return this.fetch
            .getSome(this.baseUrl, notifs.map((notif) => notif.device_id))
            .req.pipe(map((devices) => {
            for (let i = 0; i < notifs.length; i++) {
                notifs[i].device = devices[i];
            }
            return notifs;
        }));
    }
    joinNotificationsPipe() {
        return pipe(switchMap((notifs) => {
            if (notifs.length === 0) {
                return of(notifs);
            }
            return this.joinNotifications(notifs);
        }));
    }
    joinLocations(locs) {
        return forkJoin(locs.map((loc) => this.getFromLocation(loc).pipe(map((devs) => {
            loc.bridge = devs.br;
            loc.ws = devs.ws;
            return loc;
        }))));
    }
    joinLocationPipe() {
        return pipe(switchMap((loc) => this.joinLocations([loc])), map((loc) => loc[0]));
    }
    joinLocationsPipe() {
        return pipe(switchMap((locs) => this.joinLocations(locs)));
    }
    getDeviceType(id) {
        return this.get(id).pipe(map((device) => device));
    }
}
DeviceService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function DeviceService_Factory() { return new DeviceService(i0.ɵɵinject(i1.Fetch), i0.ɵɵinject(i2.Cache)); }, token: DeviceService, providedIn: "root" });
